<template>
  <v-card>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="6" md="7" class="headline mb-1 text--primary">
          {{ contratacao.transportadora.pessoa.nome }}
          <px-popover-transportador :transportador="contratacao.transportadora"/>
          <px-situacao-contratacao-frete-tag :situacao="contratacao.situacao"/>
          <px-contratacao-frete-cancelar-dialog v-if="!isCancelada"
                                                :contratacao="contratacao"
                                                @movimentar="onCancel"/>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="5"
               class="text-sm-right">
          <span class="headline blue--text text--darken-3">
            {{ contratacao.total | currency }}
          </span>
          <div class="caption">total</div>
        </v-col>
      </v-row>
      <p>
        <v-icon>mdi-domain</v-icon>
        {{ contratacao.transportadora.pessoa.cnpj | cnpj }}
      </p>
      <p>
        <v-icon>mdi-identifier</v-icon>
        <px-span-tooltip top :text="contratacao.identificador"
                         tooltip="Identificador"/>
      </p>
      <px-contratacao-detalhes-card-locais :contratacao="contratacao"/>
      <px-contratacao-detalhes-card-dados-basicos :contratacao="contratacao"/>
    </v-card-text>
  </v-card>
</template>

<script>
import { SituacaoContratacaoFrete } from 'px-business-components';
import ContratacaoDetalhesCardLocais from './ContratacaoDetalhesCardLocais.vue';
import ContratacaoDetalhesCardDadosBasicos from './ContratacaoDetalhesCardDadosBasicos.vue';
import ContratacaoFreteCancelarDialog from '../cancelamento/ContratacaoFreteCancelarDialog.vue';

export default {
  props: {
    contratacao: Object,
  },
  computed: {
    isCancelada() {
      return SituacaoContratacaoFrete.keys.CANCELADO.key === this.contratacao.situacao;
    },
  },
  methods: {
    onCancel() {
      this.$emit('movimentar');
    },
  },
  components: {
    pxContratacaoDetalhesCardLocais: ContratacaoDetalhesCardLocais,
    pxContratacaoDetalhesCardDadosBasicos: ContratacaoDetalhesCardDadosBasicos,
    pxContratacaoFreteCancelarDialog: ContratacaoFreteCancelarDialog,
  },
};
</script>
